import http from '@/plugins/axios/axios';

export default class LogOperacaoService {  

    pesquisar(requisicao) {       
        return http.post('/api/adm/log-operacao/pesquisar', requisicao);
    }

    listarUsuarios(requisicao) {       
        return http.post('/api/adm/log-operacao/listar', requisicao);
    }
}